import { styled as o } from "@lokalise/styled";
import { value as t } from "../../../../utils/theme/index.js";
import { Flex as f } from "../../../Flex/Flex.js";
const i = o(f)`
	font-family: ${t("font.family.default")};
`;
export {
  i as Container
};
//# sourceMappingURL=styles.js.map
